export const SHIWA_JSON_OUTPUT_DIR = '/static/portal/sw/json/';
